var map = {
	"./open-case_1_СS2_Roulette.mp3": 247,
	"./open-case_2_Club_House.mp3": 438,
	"./open-case_3_Slam.mp3": 459,
	"./open-case_4_Protection.mp3": 708,
	"./open-case_5_Parsec.mp3": 30,
	"./sell.mp3": 666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 374;